import { CommonModule }         from '@angular/common';
import { FormsModule }          from '@angular/forms';
import { NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { TranslateModule }      from '@ngx-translate/core';

import { DirectivesModule }         from '../directives/directives.module';
import { EmailExportComponent }    from '../../export/email-export.component';
import { FileUploadComponent }     from '../../core/directives/file-upload/file-upload.component';
import { FlipperComponent }        from './flipper/flipper.component';
import { IconComponent }          from './icon/icon.component';
import { ImageViewModule }        from './image-viewer/image-viewer.module';
import { ListBoxComponent }       from './list-box/list-box.component';
import { WizardComponent }        from './wizard/wizard.component';
import { WizardStepComponent }    from './wizard/wizard.step.component';

@NgModule({
  declarations: [
    EmailExportComponent,
    FileUploadComponent,
    FlipperComponent,
    IconComponent,
    ListBoxComponent,
    WizardComponent,
    WizardStepComponent
  ],
  entryComponents: [
    EmailExportComponent,
    FileUploadComponent,
    FlipperComponent,
    IconComponent,
    ListBoxComponent,
    WizardComponent,
    WizardStepComponent
  ],
  exports: [
    CommonModule,
    FormsModule,

    EmailExportComponent,
    FileUploadComponent,
    FlipperComponent,
    IconComponent,
    ImageViewModule,
    ListBoxComponent,
    WizardComponent,
    WizardStepComponent
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,

    //Third Party
    NgbProgressbarModule,
    TranslateModule,

    //Custom
    DirectivesModule,
    ImageViewModule
  ]
})
export class ComponentsModule {}
